import type { ComponentType } from "react";
import { CsvFileIcon } from "./CsvFileIcon";
import { DocumentFileIcon } from "./DocumentFileIcon";
import { DocxFileIcon } from "./DocxFileIcon";
import { HtmlFileIcon } from "./HtmlFileIcon";
import { PdfFileIcon } from "./PdfFileIcon";
import { PptxFileIcon } from "./PptxFileIcon";
import { XlsxFileIcon } from "./XlsxFileIcon";

type FileIconProps = {
  className?: string;
};

const FILE_ICONS: Record<string, ComponentType<FileIconProps>> = {
  pdf: PdfFileIcon,
  docx: DocxFileIcon,
  pptx: PptxFileIcon,
  xlsx: XlsxFileIcon,
  csv: CsvFileIcon,
  html: HtmlFileIcon,
  md: DocumentFileIcon,
};

type Props = FileIconProps & {
  type?: string;
  extension?: string;
};

export function FileTypeIcon({ type, extension, className }: Props) {
  const typeKey = type?.trim().toLowerCase() ?? "";
  const extensionKey = extension?.trim().toLowerCase().replace(/^\./, "") ?? "";
  const Icon = FILE_ICONS[typeKey] ?? FILE_ICONS[extensionKey] ?? DocumentFileIcon;
  return <Icon className={className} />;
}
